import { Component, HostBinding, Input } from '@angular/core';
import { ButtonComponent } from '../core/button.component';

@Component({
  selector: 'spb-primary-button',
  templateUrl: './primary-button.component.html',
})
export class PrimaryButtonComponent extends ButtonComponent {
  @HostBinding('class.spb-primary-button') hostBaseClass = true;
  @Input() flat = false;
}
